
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-outcomes",
      function () {
        return require("private-next-pages/career-outcomes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-outcomes"])
      });
    }
  